module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmYUtfBBc4.9b3766ef.woff2";